export function wait(ms: number) {
  return new Promise(resolve => setTimeout(resolve, ms))
}

export function waitRandom(min: number, max: number) {
  return wait(Math.floor(Math.random() * (max - min + 1) + min))
}

export function waitForDocumentReady(): Promise<null> {
  return new Promise(resolve => {
    if (document.readyState === 'complete') {
      resolve(null)
    } else {
      const listener = () => {
        if (document.readyState === 'complete') {
          document.removeEventListener('readystatechange', listener)
          resolve(null)
        }
      }
      document.addEventListener('readystatechange', listener)
    }
  })
}
